"use client"

import { motion } from "framer-motion"

export function AnimatedMouse({
  x,
  y,
  isClicking
}: {
  x: number | string
  y: number | string
  isClicking: boolean
}) {
  return (
    <motion.div
      className="absolute top-0 left-0 z-50 pointer-events-none"
      animate={{ x, y }}
      transition={{
        type: "spring",
        stiffness: 100,
        damping: 20,
        mass: 0.8
      }}
    >
      <motion.div
        animate={{ scale: isClicking ? 0.8 : 1 }}
        transition={{ duration: 0.1 }}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="drop-shadow-md text-zinc-900 dark:text-zinc-100"
        >
          <path
            d="M5.5 3.21V20.8c0 .45.54.67.85.35l4.86-4.86c.15-.15.35-.22.56-.22h6.05c.44 0 .66-.54.35-.85L6.35 3.39c-.31-.31-.85-.1-.85.34"
            fill="currentColor"
          />
          <path
            d="M5.5 3.21V20.8c0 .45.54.67.85.35l4.86-4.86c.15-.15.35-.22.56-.22h6.05c.44 0 .66-.54.35-.85L6.35 3.39c-.31-.31-.85-.1-.85.34"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </motion.div>
    </motion.div>
  )
}
